export { LaundryRoomIcon } from './LaundryRoomIcon'
